/**
 * <predictive-search>: live search suggestions rendered server-side by
 * sections/predictive-search.liquid via the Section Rendering API.
 */

const { config, debounce } = window.Theme;

class PredictiveSearch extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('input[type="search"]');
    this.results = document.getElementById(this.dataset.resultsId);
    this.controller = null;

    this.input.addEventListener('input', debounce(() => this.search(), 250));
    this.input.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.input.value) {
        event.stopPropagation();
        this.clear();
      }
    });
  }

  async search() {
    const terms = this.input.value.trim();
    if (terms.length < 2) return this.clear();

    this.controller?.abort();
    this.controller = new AbortController();

    const url = new URL(config.routes.predictiveSearch, window.location.origin);
    url.searchParams.set('q', terms);
    url.searchParams.set('section_id', 'predictive-search');
    url.searchParams.set('resources[type]', 'query,product,collection,page');
    url.searchParams.set('resources[limit]', '4');
    url.searchParams.set('resources[options][fields]', 'title,product_type,variants.title,vendor,tag');

    try {
      const response = await fetch(url, { signal: this.controller.signal });
      if (!response.ok) throw new Error(response.status);
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const content = html.querySelector('[data-predictive-results]');
      this.results.replaceChildren(...(content ? [content] : []));
      this.input.setAttribute('aria-expanded', content ? 'true' : 'false');
    } catch (error) {
      if (error.name !== 'AbortError') this.clear();
    }
  }

  clear() {
    this.controller?.abort();
    this.results.replaceChildren();
    this.input.setAttribute('aria-expanded', 'false');
  }
}

if (!customElements.get('predictive-search')) customElements.define('predictive-search', PredictiveSearch);
